import { Navigate, Route, Routes } from 'react-router-dom';
import { useIsV2 } from '@data';
import { HomePage, LogoutPage, ReportPage } from '@pages';
import { Header } from '@components';
import { paths } from '@constants';

const LandingRedirect = () => {
  const isV2 = useIsV2();

  // The pane opens on "/" (and a logout returns there), which sends the user to their
  // landing screen: the new home screen for v2, otherwise straight to reporting.
  const path = isV2 ? paths.home : paths.report;
  return <Navigate to={path} replace />;
};

export const AppRoutes = () => (
  <>
    <Header />
    <Routes>
      <Route path={paths.root} element={<LandingRedirect />} />
      <Route path={paths.home} element={<HomePage />} />
      <Route path={paths.report} element={<ReportPage />} />
      <Route path={paths.logout} element={<LogoutPage />} />
    </Routes>
  </>
);
